<template>
  <div class="item">
    <div class="image-box">
      <img :src="imgPath" :alt="'Icon: ' + text">
    </div>
    <div class="text-box">
      <p v-html="text" />
    </div>
  </div>
</template>

<script>
  export default {
    name: "ProfileFactsItem",
    props: {
      image: {
        type: String
      },
      text: {
        type: String
      }
    },
    data() {
      return {
        imgPath: require('../assets/images/' + this.image)
      }
    }
  }
</script>

<style scoped>
  .item {
    min-width: 260px;
    display: block;
    padding-right: 50px;
  }
  .image-box {
    min-width: 100px;
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  }
  img {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
  p {
    font-size: 18px;
    margin-top: 0;
  }
  @media(max-width: 999px) {
    .item {
      min-width: 29vw;
      max-width: 29vw;
    }
    p {
      font-size: 16px;
    }
  }
  @media(max-width: 767px) {
    .item {
      min-width: 38vw;
      max-width: 38vw;
      margin-top: 15px;
      padding-right: 35px;
    }
    p {
      font-size: 15px;
    }
  }
  @media(max-width: 567px) {
    .item {
      min-width: 60vw;
      max-width: 60vw;
    }
  }
</style>